// @flow

export function isVoucher(paymentMethodCode: string): boolean {
  return VOUCHER_PAYMENT_METHOD_CODES.includes(paymentMethodCode);
}

const VOUCHER_PAYMENT_METHOD_CODES = [
  'baloto',
  'boleto',
  'cash',
  'eft',
  'multicaja',
  'oxxo',
  'oxxopay',
  'pagoefectivo',
  'safetypay-cash',
  'safetypay-online',
  'safetypay',
  'sencillito',
  'servipag',
  'spei',
  'tef',
  'webpay',
];
